import ExecAPI from 'appRoot/api/api';

/**
 * Returns live details about all configured environments.
 */
export function GetEnvironmentInfo()
{
	return ExecAPI("ReleaseData/GetEnvironmentInfo");
}
/**
 * Returns details about recent builds.
 */
export function GetRecentBuilds()
{
	return ExecAPI("ReleaseData/GetRecentBuilds");
}
/**
 * Begins creating a new release.
 */
export function CreateRelease(environmentName, name, buildId, appSettingsFrom, description)
{
	return ExecAPI("ReleaseData/CreateRelease", { environmentName, name, buildId, appSettingsFrom, description });
}
/**
 * Renames a release. Fails if the release is currently installed in any web applications.
 */
export function ChangeReleaseName(environmentName, releaseName, newName)
{
	return ExecAPI("ReleaseData/ChangeReleaseName", { environmentName, releaseName, newName });
}
/**
 * Changes the description of a release.
 */
export function ChangeReleaseDescription(environmentName, releaseName, description)
{
	return ExecAPI("ReleaseData/ChangeReleaseDescription", { environmentName, releaseName, description });
}
/**
 * Changes the AppSettings installed in a release.
 * @param {String} environmentName Environment Name
 * @param {String} releaseName Release Name
 * @param {String} appSettings AppSettings content.
 * @param {Boolean} force True to bypass the environment check.  Required if fixing an AppSettings sync issue.
 * @returns A promise that resolves or rejects when the API request completes or fails.
 */
export function ChangeReleaseAppSettings(environmentName, releaseName, appSettings, force)
{
	return ExecAPI("ReleaseData/ChangeReleaseAppSettings", { environmentName, releaseName, appSettings, force });
}
/**
 * Installs the release in one of the predefined web apps.
 */
export function InstallRelease(environmentName, releaseName, appName, overrideLockouts)
{
	return ExecAPI("ReleaseData/InstallRelease", { environmentName, releaseName, appName, overrideLockouts });
}
/**
 * Moves the release into a compressed archive where the release will no longer be accessible to this service unless manually extracted by an administrator.
 * @param {String} environmentName Environment Name
 * @param {String} releaseName Release Name
 * @returns A promise that resolves or rejects when the API request completes or fails.
 */
export function ArchiveRelease(environmentName, releaseName)
{
	return ExecAPI("ReleaseData/ArchiveRelease", { environmentName, releaseName });
}
/**
 * Recycles the app pools for the given app and returns the names of the app pools that were recycled.
 * @param {String} environmentName Environment Name
 * @param {String} appName App Name
 * @param {String} appPoolName If not null or empty, this is the name of the app pool which should be recycled.
 * @returns A promise that resolves or rejects when the API request completes or fails.
 */
export function RecycleAppPools(environmentName, appName, appPoolName)
{
	return ExecAPI("ReleaseData/RecycleAppPools", { environmentName, appName, appPoolName });
}
/**
 * Runs integration tests for the given app and returns a basic success response if tests succeed, otherwise returns an error response containing the error result(s) as the error string.
 * @param {String} environmentName Environment Name
 * @param {String} appName App Name
 * @param {String} runId Client-generated unique ID for this test run, enabling live status polling via GetIntegrationTestStatus.  May be omitted.
 * @returns A promise that resolves or rejects when the API request completes or fails.
 */
export function RunIntegrationTests(environmentName, appName, runId)
{
	return ExecAPI("ReleaseData/RunIntegrationTests", { environmentName, appName, runId });
}
/**
 * Gets the live status of an integration test run previously started by RunIntegrationTests with the same runId.
 * @param {String} runId The run ID that was passed to RunIntegrationTests.
 * @returns A promise that resolves or rejects when the API request completes or fails.
 */
export function GetIntegrationTestStatus(runId)
{
	return ExecAPI("ReleaseData/GetIntegrationTestStatus", { runId });
}
/**
 * Triggers the next IIS Log Sync with all agents to occur now, overriding the normal schedule.
 * @returns A promise that resolves or rejects when the API request completes or fails.
 */
export function TriggerIISLogSync()
{
	return ExecAPI("ReleaseData/TriggerIISLogSync");
}
/**
 * Gets the AppSettings content for a particular release from all agents.
 * @param {String} environmentName Environment Name
 * @param {String} releaseName Release Name
 * @returns A promise that resolves or rejects when the API request completes or fails.
 */
export function GetAppSettingsAllAgents(environmentName, releaseName)
{
	return ExecAPI("ReleaseData/GetAppSettingsAllAgents", { environmentName, releaseName });
}